export default "__VITE_ASSET__d44c00ae__"